import React from "react";
//import MarchMadnessLandingPage from "./MarchMadnessLandingPage.js"
import NFLLandingPage from "./NFLLandingPage.js"


const LandingPage = (props) => {



  return (
    <NFLLandingPage />
    /*<MarchMadnessLandingPage /> */
  );
}

export default LandingPage;
